import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { enqueueSnackbar } from 'notistack'

import { deactivateEvent } from '../../../api/events/index';
import Modal from '../../common/modal/Modal';
import Button from '../../common/button/Button';
import './StylesDeactivateModal.scss';

const DeactivateEventModal = ({ handleClose, eventId, refetch }) => {
  const {
    isLoading,
    isError,
    isSuccess,
    mutate
  } = useMutation(() => deactivateEvent({eventId}));

  const handleDeactivate = () => mutate();

  useEffect(() => {
    if (!isError && !isLoading && isSuccess) {
      enqueueSnackbar('Event deactivated', { variant: 'success' });
      refetch();
      handleClose();
    }

    if(!isLoading && isError) {
      enqueueSnackbar('Issues with event deactivation', { variant: 'error' });
      handleClose();
    }
  }, [isLoading, isError, handleClose, isSuccess, refetch])

  return (
    <Modal
      title='Deactivate Event'
      onClose={handleClose}
    >
      <div className='DeactivateEventModal'>
        <span>
          Please confirm that you would like to mark this event as deactivated.
        </span>
        <Button
          isModal
          isLoading={isLoading}
          onClick={handleDeactivate}
        >
          Confirm
        </Button>
      </div>
    </Modal>
  )
}

export default DeactivateEventModal;